export const patterns = {
  none: {
    source: null,
    scale: 1
  },
  bones: {
    source: require('@/assets/patterns/bones.svg'),
    scale: 0.05
  },
  circles: {
    source: require('@/assets/patterns/circles.svg'),
    scale: 2
  },
  food: {
    source: require('@/assets/patterns/food.svg'),
    scale: 0.07
  },

  japanese: {
    source: require('@/assets/patterns/japanese.svg'),
    scale: 1
  },
  plaid: {
    source: require('@/assets/patterns/plaid.svg'),
    scale: 1
  },
  polygonal: {
    source: require('@/assets/patterns/polygonal.svg'),
    scale: 1
  },
  sprinkles: {
    source: require('@/assets/patterns/sprinkles.svg'),
    scale: 1
  },
  stars: {
    source: require('@/assets/patterns/stars.svg'),
    scale: 1.5
  },
  triangles: {
    source: require('@/assets/patterns/triangles.svg'),
    scale: 1
  },
} as const;

export type PatternName = keyof typeof patterns;
export type Pattern = typeof patterns[PatternName];

export const getPattern = (name: PatternName): Pattern => {
  return patterns[name];
};
